import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// @mui
// import { useTheme } from '@mui/material/styles';
import { Box, Link } from '@mui/material';
import logoImage from '../../Logo/watch-nod.png';
import dashboardLogoImage from '../../Logo/logo-watch-nod.png';

// ----------------------------------------------------------------------
// eslint-disable-next-line
const Logo = forwardRef(({ disabledLink = false, sx, ...other }, ref) => {
  // const theme = useTheme();

  // const PRIMARY_LIGHT = theme.palette.primary.light;

  // const PRIMARY_MAIN = theme.palette.primary.main;

  // const PRIMARY_DARK = theme.palette.primary.dark;

  // OR using local (public folder)
  // -------------------------------------------------------
  const isDashboardRoute = window.location.pathname.startsWith('/dashboard');
  const logo = (
    <Box
      component="img"
      src={isDashboardRoute ? dashboardLogoImage : logoImage}
      sx={{
        width: '100%',
        maxWidth: 140,
        height: 'auto',
        cursor: 'pointer',
        ...sx,
      }}
    />

  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return (
    <Link to="/" component={RouterLink} sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
};

export default Logo;
